import {Component, Input, OnInit} from "@angular/core";
import {DOCUMENT_TYPES, ITEM_ID_TYPE} from "../../enums/enums";
import {CollectionService} from "../../services/collection.service";
import {ModalService} from "../../services/modal.service";
import {WatchService} from "../../services/watch.service";
import {paramsHelper} from "../../helpers/params-helper";
import {IDocument} from "../../interfaces/document.definition";
import {query} from "../../helpers/jp";


@Component({
  selector: "nv-item-id",
  templateUrl: "./nv-item-id.component.html"
})


export class NvItemIdComponent implements OnInit {
  @Input() document: any;
  @Input() prop: string;
  @Input() type: ITEM_ID_TYPE;

  _label: string;
  @Input() set label(v: string) {
    this._label = v;
  }

  get label(): string {
    return this._label || this.prop;
  }

  _name: string;
  get name(): string {
    return `${this.getCurrentValue()} : ${this._name}`;
  }


  constructor(private collectionService: CollectionService,
              private modalService: ModalService,
              private watchService: WatchService) {
    this.setDefaultName();

    // todo: label with (id -> name)
    // todo: when it has something selected -> load this document and update label
  }


  private getCurrentValue() {
    return this.document[this.prop];
  }


  ngOnInit(): void {
    this.loadDocument();
  }


  onChangeClick() {
    this.modalService.showSelector22(paramsHelper.modalCollectionConfig(this.type))
      .subscribe(
        document => this.updateDocument(document));
  }


  private updateDocument(document: IDocument) {
    let p = "id"; // todo: depends on this.type
    this.document[this.prop] = document[p];
    this.watchService.notify();
    this.updateLabel(document);
  }


  private loadDocument() {
    const search = paramsHelper.search()
      .addNumberParam("id", this.getCurrentValue())
      .json;

    const params = paramsHelper.loader()
      .setEndpointApi()
      .setObjectType(DOCUMENT_TYPES.GO)
      .setNavParams(0, 1)
      .setSearchParams(search);

    this.collectionService
      .loadChunk(params)
      .subscribe(
        result => {
          this.updateLabel(result.documents[0]);
        });
  }


  private updateLabel(document: IDocument) {
    if (!document) {
      this.setDefaultName();
      return;
    }

    // todo: get name of 'label' prop, read it, set to label
    console.log(JSON.stringify(this.document));
    this._name = query(document, "locales.[key=name].value.0");
  }


  private setDefaultName() {
    this._name = "loading...";
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-item-id/nv-item-id.component.ts